const customFieldValuesEqual = (left: any, right: any): boolean => {
  if (Array.isArray(left) && Array.isArray(right)) {
    return left.length === right.length && left.every((value, index) => value === right[index]);
  }
  return left === right;
};

export const mergeIncomingValues = (
  localValues: Record<string, any>,
  previousOriginalValues: Record<string, any>,
  incomingValues: Record<string, any>
): Record<string, any> =>
  Object.keys(incomingValues).reduce(
    (merged, fieldId) => {
      const localValue = localValues[fieldId];
      const hasDivergentLocalEdit =
        !customFieldValuesEqual(localValue, previousOriginalValues[fieldId]) &&
        !customFieldValuesEqual(localValue, incomingValues[fieldId]);

      merged[fieldId] = hasDivergentLocalEdit ? localValue : incomingValues[fieldId];
      return merged;
    },
    {} as Record<string, any>
  );
